import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneRequiredValidator(fieldKeys: string[]): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const atLeastOneFilled = fieldKeys.some(key => {
      const control = formGroup.get(key);
      return control && control.value;
    });

    return atLeastOneFilled ? null : { atLeastOneRequired: true };
  };
}
